<template>
<div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-3 col-md-12 col-2 mb-3">
                    <h2>Deleted Bid Wanteds </h2>
                    </div>
                    <div class="col-lg-9 col-md-12 col-10 text-right bid">
                    <div class="input-group d-inline-flex justify-content-end">
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                            <i @click="searchHolding()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                            <input v-on:keyup.enter="searchHolding" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search cusip" aria-label="Search">
                            <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>
                    </div>
                </div>
                    
                </div>
                <!-- Card stats -->
                </div>
            </div>
        </div>
           <div class="container-fluid mt--6 filter-show">
                <div class="card w-100 p-2 mb-2  d-inline-block">
                <div class="d-flex justify-content-between">
         <h5 class="ml-3">Filters</h5>
         <span class="btn btn-link" @click="showFilters = !showFilters">
         <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
         </span>
                </div>
      <div class="row" v-if="showFilters">
         <div class="col-lg-12">
            <form class="row">
               <div class="col-md-6 col-lg-2">
                  <label for="filter" class="col-form-label">From</label>
                  <datepicker v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
               </div>
               <div class="col-md-6 col-lg-2">
                  <label for="filter" class="col-form-label">To</label>
                  <datepicker v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
               </div>
               <div class="col-md-6 col-lg-2">
                  <button @click="clearFilter()" type="button" class="btn btn-secondary rounded top-2">Clear</button>
                  <button :disabled="!fromDate || !toDate" @click="searchHolding()" type="button" class="btn btn-primary rounded top-2">Filter</button>
               </div>
            </form>
         </div>
      </div>
        </div>
    </div>
        <div class="container-fluid">
            <div class="row xsOnly">
                <div class="col-xl-12">
                <div class="card scrollbar vh-75" id="scroll">
                    <div class="table-responsive">
                        <table class="table align-items-center table-flush table-hover bidtbl bid-acc">
                            <thead class="thead-light psticky">
                            <tr >
                                <!-- <th 
                                scope="col" 
                                class="sort text-left"
                                >CUSTOMER <br>ACCOUNT | TYPE</th> -->
                                <th 
                                scope="col" 
                                class="sort text-center"
                                >CUSIP</th>
                                <!-- <th
                                scope="col"
                                class="sort text-center"
                                >BOUGHT
                                </th> -->
                                <th 
                                scope="col" 
                                class="sort text-center"
                                >COST</th>
                                <!-- <th 
                                scope="col" 
                                class="sort text-center"
                                >CLOSING PX</th> -->
                                <th 
                                scope="col" 
                                class="sort text-center"
                                >TRADER/ADMIN</th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                >OPERATOR</th>
                                <th 
                                scope="col" 
                                class="sort text-center"
                                >SELL QTY</th> 
                                <th 
                                scope="col" 
                                class="sort text-center"
                                >ACTION</th>
                            </tr>
                            </thead>
                            <tbody class="list">
                            <tr v-if="totalRows == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="holding in holdingsList" :key="holding.id"  >
                                <!-- <td class="text-left">
                                <span class="text-primary">{{holding.customerFirstName ? holding.customerFirstName[0] : ""}} {{holding.customerLastName}}</span><br>
                                <span>{{holding.accountVal}}</span> | 
                                <span class="text-success">{{holding.accountType}}</span> 
                                </td> -->
                                <td class="text-center">
                                    <span class="cusips">{{holding.cusipVal}}</span><br>
                                </td>
                                <!-- <td class="text-center">
                                    <span>{{holding.boughtDate ? moment(holding.boughtDate).format("MM/DD/YYYY") : 'N/A'}}</span><br>
                                </td> -->
                                <td class="text-center">
                                    <span class="text-success">{{holding.cost | currency}}</span><br>
                                </td>
                                <!-- <td class="text-center">
                                    <span class="text-danger">{{holding.closingPx}}</span><br>
                                </td> -->
                                <td class="text-center">
                                    <span>{{holding.traderFirstName}} {{holding.traderLastName}}</span><br>
                                </td>
                                <td class="text-center">
                                    <span>{{holding.operatorFirstName}} {{holding.operatorLastName}}</span>
                                    
                                    <!-- <span class="text-success" v-if="holding.operatorCognitoSub === cognitoSub">Me</span> -->
                                </td>   
                                <td class="text-center">
                                    <span>{{holding.sellQuantity}}</span>
                                </td> 
                                <td class="text-center">
                                    <button v-if="holding.highBidId" @click="toggleViewBidWantedModalOpen(holding);selectedHolding = holding" type="button" class="btn btn-primary mb-2" >BIDS</button>
                                </td>
                                </tr>
                            </tbody>
                            <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getHoldingList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        <ViewBidWanted v-bind:holding="selectedHolding" v-if="viewBidWantedModalOpen" @close="toggleViewBidWantedModalOpen()" />
        </div>  
    </div> 
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import ViewBidWanted from './ba-common/BaViewBidWantedModal';
import Datepicker from 'vuejs-datepicker';

export default {
  name: "baAllHoldingsTrader",
  components : {
    ViewBidWanted,
    Datepicker
  },
  data() {
    return {
        loading : false,
        currentPage: 1,
        perPage: 20,
        searchValue : "",
        sortColumn: "id",
        sortOrder:"ASC",
        totalRows : 0,
        viewBidWantedModalOpen : false,
        holdingsList : [],
        selectedHolding : null,
        cognitoSub : authService.getUser().cognitoSub,
        showFilters : false,
        fromDate : "",
        toDate : "",
    };
  },
  methods: {
    searchHolding(){
      this.currentPage = 1;
      this.getHoldingList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.currentPage = 1;
      this.getHoldingList(); 
    },
    clearFilter(){
      this.fromDate = this.moment().format("MM-DD-YYYY");
      this.toDate = this.moment().add(1,'days').format("MM-DD-YYYY");
      this.getHoldingList();
    },
    getHoldingList(){
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        var fDate = this.fromDate ? this.moment(this.fromDate).format("YYYY-MM-DD") : "";
        var tDate = this.toDate ?  this.moment(this.toDate).format("YYYY-MM-DD") : "";
        this.$http
        .get(
           config.baseUrlBidSide +
            "/bidwanted/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=DELETED,DAILY_DELETE"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&deletedFromDate="+
            fDate+
            "&deletedToDate="+
            tDate,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.holdingsList = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    },
    toggleViewBidWantedModalOpen(){
      this.viewBidWantedModalOpen = !this.viewBidWantedModalOpen;
    }
  },
  mounted() {
    this.fromDate = this.moment().format("MM-DD-YYYY");
    this.toDate = this.moment().add(1,'days').format("MM-DD-YYYY");
    this.getHoldingList();

  }
};
</script>